import React from "react";

const SectionBreak = () => {
    return (
        <hr className='col-8 my-0' />
    );
}

export default SectionBreak;